export default __webpack_public_path__ + "static/media/umberto-eco-antilibrary.d3f79b2b.webp";